<!-- 首页 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 赋能 -->
    <Empower‌ment></Empower‌ment>
    <!-- 开放共赢 -->
    <OpennessWinWin></OpennessWinWin>
    <!-- 隐形枷锁 -->
    <InvisibleShackles></InvisibleShackles>
    <!-- 四大生态 -->
    <FourEcosystems></FourEcosystems>
    <!-- 选择易隆创 -->
    <Decision></Decision>
    <!-- 生态领航 -->
    <Piloting></Piloting>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import InvisibleShackles from "./components/InvisibleShackles.vue";
import FourEcosystems from "./components/FourEcosystems.vue";
import Empower‌ment from "./components/Empower‌ment.vue";
import OpennessWinWin from "./components/OpennessWinWin.vue";
import Decision from "./components/Decision.vue";
import Piloting from "./components/Piloting.vue";

export default {
  components: {
    Banner,
    InvisibleShackles,
    FourEcosystems,
    Empower‌ment,
    OpennessWinWin,
    Decision,
    Piloting,
  },
  methods:{

  }
};
</script>

<style lang="less" scoped>
</style>
